export default __webpack_public_path__ + "static/before-after-2@2x-dfbc2b961eec5bd05cd4f111f01cb35c.jpg";